// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xe_a bhb_uj bhb_ua bhb_vx bhb_qk bhb_sl bhb_qb"};